import { defineMessages } from "react-intl";

export const sectionMessages = defineMessages({
  channels: {
    defaultMessage: "Channels",
    id: "misc/commonMessages/95qy1d",
    description: "section name",
  },
  customization: {
    defaultMessage: "Customization",
    id: "misc/commonMessages/gnUZny",
    description: "section name",
  },
  settings: {
    defaultMessage: "Settings",
    id: "misc/commonMessages/g8hTTQ",
    description: "section name",
  },
});
